// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/FilterButtonDropDown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autoComplete > span.jewel {
  height: 30px;
  width: 31px;
  display: inline-block;
  position: absolute;
  left: calc(100% - 32px);
  top: 1px;
  border: 1px transparent;
  border-radius: 0 2px 2px 0;
  background-size: 16px !important;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
}
.autoComplete > span.clear {
  height: 30px;
  width: 30px;
  display: inline-block;
  position: absolute;
  left: -9999px;
  top: 1px;
  border: 1px transparent;
  border-radius: 0 2px 2px 0;
  background-size: 10px !important;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
}
.autoComplete > span.clear.active {
  left: calc(100% - 63px);
}
.autoComplete > span.clear.active + div > input {
  padding-right: 60px;
}
.autoComplete > div {
  width: 100%;
  margin-left: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: "Aeonik", sans-serif;
  border-radius: 3px;
  font-size: 12px;
  line-height: 16px;
  color: #002E33;
  height: 32px;
  background-color: #F5F6F9;
}
.autoComplete > div > input {
  padding-right: 31px !important;
}
.autoComplete .menu-container {
  position: absolute;
  width: 100%;
  z-index: 1003;
  background: #FFF;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}
.autoComplete .menu-container > .action-btn {
  color: #002E33;
  font-weight: 600;
  margin-top: 10px;
  font-size: 12px;
  cursor: pointer;
}
.autoComplete .menu-container > .action-btn div {
  border-top: 1px solid #E8E9F0;
  padding-left: 8px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.autoComplete .menu-items {
  cursor: pointer;
  max-height: 290px;
  overflow-y: auto;
}
.autoComplete .menu-items .highLightedItem {
  background-color: #F5F6F9;
}
.autoComplete .menu-items .DropdownItemUnavailable {
  opacity: 0.4;
  cursor: no-drop;
}
.autoComplete .menu-items > div {
  display: block;
  padding: 5px 6px;
  padding-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.autoComplete.readOnly .jewel, .autoComplete.readOnly .clear {
  display: none;
}
.autoComplete.readOnly div {
  background-color: none;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/CustomAutoComplete/CustomAutoComplete.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAIE;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,uBAAA;EACA,0BAAA;EACA,gCAAA;EACA,eAAA;EACA,oEAAA;AAHJ;AAKE;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,0BAAA;EACA,gCAAA;EACA,eAAA;EACA,oEAAA;AAHJ;AAKE;EACE,uBAAA;AAHJ;AAKM;EACE,mBAAA;AAHR;AAQE;EACE,WAAA;EACA,cAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC7CW;ED8CX,YAAA;EACA,yBCSK;ADfT;AAOI;EACE,8BAAA;AALN;AAQE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBClDI;EDmDJ,8BAAA;UAAA,sBAAA;EACA,2BAAA;EACA,wDAAA;UAAA,gDAAA;EACA,8BAAA;EACA,+BAAA;AANJ;AAOI;EACE,cC/DS;EDgET,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AALN;AAMM;EACE,6BAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAJR;AAQE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AANJ;AAQI;EACE,yBC1BG;ADoBT;AAQI;EACE,YAAA;EACA,eAAA;AANN;AAQI;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAUI;EACE,aAAA;AARN;AAUI;EACE,sBAAA;AARN","sourcesContent":["@import '../../../Global/Colors';\n\n.autoComplete{\n\n  >span.jewel {\n    height: 30px;\n    width: 31px;\n    display: inline-block;\n    position: absolute;\n    left: calc(100% - 32px);\n    top: 1px;\n    border: 1px transparent;\n    border-radius: 0 2px 2px 0;\n    background-size: 16px !important;\n    cursor: pointer;\n    background: url('~images/FilterButtonDropDown.svg') no-repeat center;\n  }\n  >span.clear {\n    height: 30px;\n    width: 30px;\n    display: inline-block;\n    position: absolute;\n    left: -9999px;\n    top: 1px;\n    border: 1px transparent;\n    border-radius: 0 2px 2px 0;\n    background-size: 10px !important;\n    cursor: pointer;\n    background: url(close.svg) no-repeat center;\n  }\n  >span.clear.active {\n    left: calc(100% - 63px);\n    +div {\n      >input {\n        padding-right: 60px;\n      }\n    }\n  }\n\n  >div {\n    width: 100%;\n    margin-left: 0;\n    box-sizing: border-box;\n    font-family: \"Aeonik\", sans-serif;\n    border-radius: 3px;\n    font-size: 12px;\n    line-height: 16px;\n    color: $DeepSeaGreen;\n    height: 32px;\n    background-color: $Gray20;\n    >input {\n      padding-right: 31px !important;\n    }\n  }\n  .menu-container {\n    position: absolute;\n    width: 100%;\n    z-index: 1003;\n    background: $White;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n    border-bottom-left-radius: 2px;\n    border-bottom-right-radius: 2px;\n    >.action-btn {\n      color: $DeepSeaGreen;\n      font-weight:600;\n      margin-top: 10px;\n      font-size: 12px;\n      cursor: pointer;\n      div {\n        border-top: 1px solid $Gray30;\n        padding-left: 8px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n      }\n    }\n  }\n  .menu-items {\n    cursor: pointer;\n    max-height: 290px;\n    overflow-y: auto;\n\n    .highLightedItem {\n      background-color: $Gray20;\n    }\n    .DropdownItemUnavailable {\n      opacity: 0.4;\n      cursor: no-drop;\n    }\n    >div {\n      display: block;\n      padding: 5px 6px;\n      padding-left: 8px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n  &.readOnly {\n    .jewel, .clear {\n      display: none;\n    }\n    div {\n      background-color: none;\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
